import { render, staticRenderFns } from "./BlackGoldProviders.vue?vue&type=template&id=f31933ec"
import script from "./BlackGoldProviders.vue?vue&type=script&lang=js"
export * from "./BlackGoldProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports